import { IRootState } from "app/model"
import { NotFoundPage } from "page/components/NotFoundPage"
import { IPage } from "page/model"
import React from "react"
import { connect } from "react-redux"
import { Routes as ReactRouterRoutes, Route } from "react-router-dom"

interface IRoutesProps {
  pages: IPage[]
  permissions: string[]
}

export const RoutesFn = React.memo(({ pages, permissions }: IRoutesProps) => (
  <ReactRouterRoutes>
    {pages
      .filter(p => {
        if (p.disabled) {
          return false
        } else if (p.usedForAdminOnly) {
          return permissions.includes("admin0permissions")
        } else if (p.usedForEverybody) {
          return true
        }
        return !permissions.includes("admin0permissions")
      })
      .map(page => (
        <Route path={page.path} key={page.path} element={<page.jsxElement />} />
      ))}
    <Route path="*" element={<NotFoundPage />} />
  </ReactRouterRoutes>
))

export const Routes = connect(
  (state: IRootState): IRoutesProps => ({
    pages: state.page.pages,
    permissions: state.user.permissions
  })
)(RoutesFn)
